<template>
    <label class="contact-full-name">
        {{ contactFullName }}
    </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
});

const contactFullName = computed(() => {
    const fullName = `${props.contact.first_name || ''} ${props.contact.last_name || ''}`.trim();

    return fullName || 'Anonymous User';
});
</script>

<style lang="scss">
.contact-full-name {
    font-family: var(--font-dm-sans);
    font-weight: var(--weight-medium);
    font-size: 0.875rem; // 14px
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}
</style>
